const replaceAll = (str, oldChar, newChar) => {
  const regex = new RegExp('\\' + oldChar, 'g')
  return str.replace(regex, newChar)
}

const converterStringParaNumero = (valor) => {
  valor = replaceAll(String(valor), '.', '');
  valor = replaceAll(String(valor), ',', '.');
  return valor && typeof valor === 'string' ? replaceAll(valor, ',', '') : valor;
}

const removerAcentos = (newStringComAcento) => {
  var string = newStringComAcento;
  var mapaAcentosHex = {
    a: /[\xE0-\xE6]/g,
    e: /[\xE8-\xEB]/g,
    i: /[\xEC-\xEF]/g,
    o: /[\xF2-\xF6]/g,
    u: /[\xF9-\xFC]/g,
    c: /\xE7/g,
    n: /\xF1/g
  };

  for (var letra in mapaAcentosHex) {
    var expressaoRegular = mapaAcentosHex[letra];
    string = String(string).replace(expressaoRegular, letra);
  }

  return string;
}

export default {
  converterStringParaNumero,
  replaceAll,
  removerAcentos
}



// WEBPACK FOOTER //
// ./src/services/Formatacao.js